import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3ChildPageState() {
  const childPage = useSelector((state: RootState) => state.treatmentPlanV3.childPage);
  const hasLoaded = childPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.childPageError != null,
  );
  const childPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.childPageLoading,
  );
  const isLoading = childPageLoading || (!hasLoaded && !hasLoadError);
  const isUpdatingBehaviorIssues = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateChildInfoLoading,
  );
  const isSavingBackground = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createChildBackgroundLoading ||
      state.treatmentPlanV3.deleteChildBackgroundLoading,
  );
  const isSavingSchedule = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.createChildScheduleLoading ||
      state.treatmentPlanV3.deleteChildScheduleLoading,
  );

  return {
    childBehaviorIssues: childPage?.child_behavior_issues ?? '',
    backgrounds: childPage?.backgrounds ?? [],
    schedules: childPage?.schedule ?? [],
    notAttendingSchool: childPage?.not_attending_school ?? false,
    isLoading,
    hasLoaded,
    hasLoadError,
    isSavingBackground,
    isSavingSchedule,
    isUpdatingBehaviorIssues,
  };
}
